import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  userInfo: [],
  products: [],
  wishlist: [],
  compared1: [],
  compared2: [],
};

export const orebiSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = state.products.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.products.push(action.payload);
      }
    },
    addToWishlist: (state, action) => {
      const item = state.products.find(
        (item) => item._id === action.payload._id);
      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.wishlist.push(action.payload);
      }
    },
    removeFromWishlist: (state, action) => {
      state.products = state.wishlist.filter(
        (item) => item._id !== action.payload._id
      );
    },
    increaseQuantity: (state, action) => {
      const item = state.products.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.quantity++;
      }
    },
    drecreaseQuantity: (state, action) => {
      const item = state.products.find(
        (item) => item._id === action.payload._id
      );
      if (item.quantity === 1) {
        item.quantity = 1;
      } else {
        item.quantity--;
      }
    },
    deleteItem: (state, action) => {
      state.products = state.products.filter(
        (item) => item._id !== action.payload
      );
    },
    resetCart: (state) => {
      state.products = [];
    },
    addToCompared: (state, action) => {
      const item1 = state.compared1.find(
        (item1) => item1._id === action.payload._id
      );
      if (!item1) {
        state.compared1.push(action.payload);
      }
    },
    removeFromCompared: (state, action) => {
      const { _id } = action.payload;
      state.compared1 = state.compared1.filter((item) => item._id !== _id);
    },
    clearCompared: (state) => {
      state.compared1 = [];
    },
    addToCompared2: (state, action) => {
      const item2 = state.compared2.find(
        (item2) => item2._id === action.payload._id
      );
      if (!item2) {
        state.compared2.push(action.payload);
      }
    },
    removeFromCompared2: (state, action) => {
      const { _id } = action.payload;
      state.compared2 = state.compared2.filter((item) => item._id !== _id);
    },
    clearCompared2: (state) => {
      state.compared2 = [];
    },
  },
});

export const {
  addToCompared,
  removeFromCompared,
  clearCompared,
  addToCompared2,
  removeFromCompared2,
  clearCompared2,
  addToCart,
  addToWishlist,
  removeFromWishlist,
  increaseQuantity,
  drecreaseQuantity,
  deleteItem,
  resetCart,
} = orebiSlice.actions;
export default orebiSlice.reducer;
// export rootReducer
